import { PagamentoWithDettaglioDTO } from '@framework/api-client';
import { EnumCodStatoPagamento } from '../burden/payments/EnumCodStatoPagamento';

export class SubmissionPaymentsLogic {
  /**
   * Vero se almeno un pagamento valido è in attesa dell'esito
   * da parte del gestore dei pagamenti.
   */
  static hasPaymentsAwaitingOutcome(
    payments: PagamentoWithDettaglioDTO[] | null | undefined,
  ): boolean {
    return (
      payments?.some(
        p =>
          p.flValido && p.codStatoPagamento === EnumCodStatoPagamento.PENDENTE,
      ) ?? false
    );
  }
}
